import React from 'react';

import { applyCypressData } from 'Utilities/index';

import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../Hooks/usePageRefEvents';
import { RoundedSection } from '../RoundedSection/RoundedSection';

import { PromoCard } from './SubComponents/PromoCard/PromoCard';
import { PromoCardsProps } from './PromoCards.types';

import styles from './PromoCards.scss';

export const PromoCards = ({
  cypressData,
  onSectionLoad,
  onTileClick,
  testId = 'promoCards',
  theme = 'primary-yellow',
  tiles,
  title,
}: PromoCardsProps) => {
  const eventLabels = tiles.map((card) => card.title);

  const {
    $wrapper,
    setRef,
  } = usePageRefEvents({ eventLabels, onRefTrigger: onSectionLoad });

  return (
    <RoundedSection withBottomLedge withBottomPadding withTopLedge theme={theme}>
      <div className={styles.componentWrapper} {...(cypressData ? applyCypressData(cypressData) : {})}>
        <Content className={styles.wrapperPaddingOverride}>
          {title && <div className={styles.headingsWrapper}>
            <h2>{title}</h2>
          </div>}

          <div className={styles.contentWrapper}>
            <section ref={$wrapper} className={styles.component} data-testid={testId}>
              {
                tiles.map((tileContent, i) => (
                  <PromoCard
                    key={`${tileContent.link}-${i}`}
                    ref={(ref) => setRef(ref, i)}
                    onClick={() => onTileClick?.(tileContent.title, tileContent.link)}
                    { ...tileContent } />
                ))
              }
            </section>
          </div>
        </Content>
      </div>
    </RoundedSection>
  );
};
